import React from 'react'
import ReturnBreadCrumbs from 'components/breadCrumb/NewBreadCrumbs'
import locationImg from 'assets/Images/location-event.svg'
import { capitalizeFirstLetter, formatAddress } from 'helper/utility'
import { CommunityResp } from 'types/community/community'
import ManageButtonCommunity from './ManageButtonCommunity'

interface ProfileHeaderCommunityProps {
  community?: CommunityResp
}

const ProfileHeaderCommunity: React.FC<ProfileHeaderCommunityProps> = ({
  community,
}) => {
  return (
    <div>
      <div className="flex justify-between">
        <ReturnBreadCrumbs
          links={[
            { name: 'Events', link: '/spaces?page=1&limit=10' },
            {
              name: `${community?.name || ''}`,
              link: `/community/${community?._id}`,
            },
          ]}
        />
        {community?._id && (
          <ManageButtonCommunity id={community._id} status={community.status} />
        )}
      </div>

      <div className="w-80p">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '40% 60%',
            gap: '50px',
          }}
        >
          <img
            src={community?.coverPhotos?.[0]?.post}
            alt="community-img"
            style={{ width: '100%', height: '300px', borderRadius: '15px' }}
          />
          <div className="">
            <h2 className="text-40 my-20px">
              {capitalizeFirstLetter(community?.name || '')}
            </h2>
            <div className="flex mt-20px">
              <div className="flex">
                <div>
                  <img src={locationImg} alt="location" />
                </div>
                <div className="ml-10px">
                  <h4 className="text-12 grey-txt">Location</h4>
                  <div>{formatAddress(community?.location)}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileHeaderCommunity
